import * as core from '../../../../../../../core'

import { query } from './value-of-change-by-workstream.query'

export const RESOURCE = {
  payload: {
    alias: 'value.of.change.by.workstream',
    description: 'Chart view of value of change by workstream',
    name: 'Value of Change by Workstream',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
